import React from 'react';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import placeholder from '../../assets/img/placehold-square.png';

import { getThumbnailUrl } from 'utils/BreakerImageAPI';
import { ProfileLinks, TeamMember as TeamMemberType } from 'types/TeamMember';

type Props = {
  teamMember: TeamMemberType;
};

type LinkProps = {
  links: ProfileLinks;
};

const Links = ({ links }: LinkProps) => {
  if (!links) {
    return null;
  }

  const linkedIn = links['linkedIn'];
  const twitter = links['twitter'];
  const artStation = links['artStation'];
  const website = links['website'];

  return (
    <span>
      {linkedIn && (
        <a href={linkedIn} target="_new">
          LinkedIn
        </a>
      )}
      {twitter && (
        <a href={twitter} target="_new">
          Twitter
        </a>
      )}
      {artStation && (
        <a href={artStation} target="_new">
          ArtStation
        </a>
      )}
      {website && (
        <a href={website} target="_new">
          Website
        </a>
      )}
    </span>
  );
};

const TeamMember = ({ teamMember }: Props) => {
  const { name, breakerId, imageUrl, title, blurb, subLine, links } = teamMember;

  let displayedImageUrl;

  if (breakerId) {
    displayedImageUrl = getThumbnailUrl(breakerId);
  } else if (imageUrl) {
    displayedImageUrl = imageUrl;
  } else {
    displayedImageUrl = placeholder;
  }

  return (
    <div className="card h-100">
      <LazyLoadImage
        className="img-fluid w-100"
        alt={name}
        src={displayedImageUrl}
        effect="opacity"
      />

      <div className="card-body d-flex flex-column justify-content-between">
        <div>
          <h5 className="mb-0">{name}</h5>
          <p className="title mb-2">{title}</p>
          <p className="mt-0 mb-3">{subLine && `"${subLine}"`}</p>
        </div>
        <div>
          <p className="text-small mt-0 mb-1">{blurb}</p>
          <p className="text-small mt-0">{links && <Links links={links} />}</p>
        </div>
      </div>
    </div>
  );
};

export default TeamMember;
